import React, {useEffect, useMemo, useRef, useState} from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, flex, onDesktop, p, pr} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {InputWrapper} from "@pg-design/inputs-module";
import {Text} from "@pg-design/text-module";

import {useClickOutside} from "../../hooks/handle_click_outside";
import {SortDropdownArrow} from "./SortDropdownArrow";
import {SortOptions} from "./SortOptions";

interface ISortOption<TValue> {
    label: string;
    value: TValue;
}

interface IProps<TValue> {
    sortOptions: ISortOption<TValue>[];
    onSave: (value: TValue | null) => void;
    defaultValue?: TValue | null;
    onChange?: (value: TValue | null) => void;
    onClear?: () => void;
    onDropdownStatusChange?: (isOpen: boolean) => void;
    dropdownPosition?: "left" | "right";
    disableClearAction?: boolean;
    dropdownShadow?: boolean;
    closeOnOutsideClick?: boolean;
}
export const SortWithRadioDropdown = <TValue extends number | string>(props: IProps<TValue>) => {
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [value, setValue] = useState(() => props.defaultValue || null);
    const wrapperRef = useRef(null);
    const currentOption = useMemo(() => {
        return props.sortOptions.find((option) => option.value === value);
    }, [value]);

    useClickOutside(wrapperRef, () => {
        if (props.closeOnOutsideClick) {
            setDropdownOpen(false);
            props.onDropdownStatusChange?.(false);
        }
    });

    useEffect(() => {
        props.onDropdownStatusChange?.(isDropdownOpen);
    }, [isDropdownOpen]);

    const handleClick = () => {
        setDropdownOpen((prevState) => !prevState);
    };

    const onClear = (event?: React.MouseEvent | React.KeyboardEvent) => {
        event?.stopPropagation?.();
        setDropdownOpen(false);
        setValue(null);
        props.onChange?.(null);
        props.onClear?.();
    };

    const onChange = (newValue: TValue) => {
        setValue(newValue);
        props.onChange?.(newValue);
    };

    const onSaveBtnClick = () => {
        setDropdownOpen(false);
        props.onSave(value);
    };

    return (
        <InputWrapper css={filterHolder} ref={wrapperRef}>
            <div tabIndex={-1} css={filterLabel} onClick={handleClick}>
                <Text variant="body_copy_2" css={filterLabelText}>
                    Sortuj
                    {!!value && (
                        <>
                            <br />
                            <Text variant="info_txt_2" as="span" css={subLabel}>
                                {currentOption?.label}
                            </Text>
                        </>
                    )}
                </Text>

                {!props.disableClearAction && value ? (
                    <div onClick={onClear}>
                        <CloseIcon size="2" />
                    </div>
                ) : (
                    <SortDropdownArrow isDown={isDropdownOpen} />
                )}
            </div>

            {isDropdownOpen && (
                <DropdownHolder dropdownPosition={props.dropdownPosition} dropdownShadow={props.dropdownShadow}>
                    <Text variant="body_copy_1">Sortuj</Text>
                    <SortOptions currentValue={value} setCurrentValue={onChange} sortOptions={props.sortOptions} onClear={onClear} onSave={onSaveBtnClick} />
                </DropdownHolder>
            )}
        </InputWrapper>
    );
};

export const filterHolder = (theme: Theme) => css`
    position: relative;
    width: 100%;
    ${p(0)};

    @media (max-width: calc(${theme.breakpoints.md} - 1px)) {
        &:focus {
            outline: none;
            box-shadow: none;
        }
    }
`;

export const filterLabel = (theme: Theme) => css`
    display: none;

    &:focus {
        outline: none;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${p(0, 2)};
        ${flex("center", "space-between")};
        height: ${calculateRemSize(6)};
        cursor: pointer;
        width: 100%;
    }
`;

const filterLabelText = css`
    ${pr(1)};
    white-space: nowrap;
`;

const DropdownHolder = styled.div<Pick<IProps<never>, "dropdownPosition" | "dropdownShadow">>`
    background: #fff;

    ${p(2, 1)};
    ${(props) =>
        onDesktop(css`
            position: absolute;
            top: 6rem;
            z-index: 1001;
            min-width: 36rem;
            max-height: 60rem;

            ${p(3, 4, 2, 4)}
            ${borderRadius(4)}
            right: ${props.dropdownPosition === "right" ? 0 : "initial"};
            ${elevation(props.dropdownShadow ? 1 : 0)};
        `)};
`;

const subLabel = (theme: Theme) => css`
    color: ${theme.colors.gray[700]};
`;
import React, {useEffect, useMemo, useRef, useState} from "react";
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, flex, onDesktop, p, pr} from "@pg-design/helpers-css";
import {CloseIcon} from "@pg-design/icons-module";
import {InputWrapper} from "@pg-design/inputs-module";
import {Text} from "@pg-design/text-module";

import {useClickOutside} from "../../hooks/handle_click_outside";
import {SortDropdownArrow} from "./SortDropdownArrow";
import {SortOptions} from "./SortOptions";

interface ISortOption<TValue> {
    label: string;
    value: TValue;
}

interface IProps<TValue> {
    sortOptions: ISortOption<TValue>[];
    onSave: (value: TValue | null) => void;
    defaultValue?: TValue | null;
    onChange?: (value: TValue | null) => void;
    onClear?: () => void;
    onDropdownStatusChange?: (isOpen: boolean) => void;
    dropdownPosition?: "left" | "right";
    disableClearAction?: boolean;
    dropdownShadow?: boolean;
    closeOnOutsideClick?: boolean;
}
export const SortWithRadioDropdown = <TValue extends number | string>(props: IProps<TValue>) => {
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [value, setValue] = useState(() => props.defaultValue || null);
    const wrapperRef = useRef(null);
    const currentOption = useMemo(() => {
        return props.sortOptions.find((option) => option.value === value);
    }, [value]);

    useClickOutside(wrapperRef, () => {
        if (props.closeOnOutsideClick) {
            setDropdownOpen(false);
            props.onDropdownStatusChange?.(false);
        }
    });

    useEffect(() => {
        props.onDropdownStatusChange?.(isDropdownOpen);
    }, [isDropdownOpen]);

    const handleClick = () => {
        setDropdownOpen((prevState) => !prevState);
    };

    const onClear = (event?: React.MouseEvent | React.KeyboardEvent) => {
        event?.stopPropagation?.();
        setDropdownOpen(false);
        setValue(null);
        props.onChange?.(null);
        props.onClear?.();
    };

    const onChange = (newValue: TValue) => {
        setValue(newValue);
        props.onChange?.(newValue);
    };

    const onSaveBtnClick = () => {
        setDropdownOpen(false);
        props.onSave(value);
    };

    return (
        <InputWrapper css={filterHolder} ref={wrapperRef}>
            <div tabIndex={-1} css={filterLabel} onClick={handleClick}>
                <Text variant="body_copy_2" css={filterLabelText}>
                    Sortuj
                    {!!value && (
                        <>
                            <br />
                            <Text variant="info_txt_2" as="span" css={subLabel}>
                                {currentOption?.label}
                            </Text>
                        </>
                    )}
                </Text>

                {!props.disableClearAction && value ? (
                    <div onClick={onClear}>
                        <CloseIcon size="2" />
                    </div>
                ) : (
                    <SortDropdownArrow isDown={isDropdownOpen} />
                )}
            </div>

            {isDropdownOpen && (
                <DropdownHolder dropdownPosition={props.dropdownPosition} dropdownShadow={props.dropdownShadow}>
                    <Text variant="body_copy_1">Sortuj</Text>
                    <SortOptions currentValue={value} setCurrentValue={onChange} sortOptions={props.sortOptions} onClear={onClear} onSave={onSaveBtnClick} />
                </DropdownHolder>
            )}
        </InputWrapper>
    );
};

export const filterHolder = (theme: Theme) => css`
    position: relative;
    width: 100%;
    ${p(0)};

    @media (max-width: calc(${theme.breakpoints.md} - 1px)) {
        &:focus {
            outline: none;
            box-shadow: none;
        }
    }
`;

export const filterLabel = (theme: Theme) => css`
    display: none;

    &:focus {
        outline: none;
    }

    @media (min-width: ${theme.breakpoints.md}) {
        ${p(0, 2)};
        ${flex("center", "space-between")};
        height: ${calculateRemSize(6)};
        cursor: pointer;
        width: 100%;
    }
`;

const filterLabelText = css`
    ${pr(1)};
    white-space: nowrap;
`;

const DropdownHolder = styled.div<Pick<IProps<never>, "dropdownPosition" | "dropdownShadow">>`
    background: #fff;

    ${p(2, 1)};
    ${(props) =>
        onDesktop(css`
            position: absolute;
            top: 6rem;
            z-index: 1001;
            min-width: 36rem;
            max-height: 60rem;

            ${p(3, 4, 2, 4)}
            ${borderRadius(4)}
            right: ${props.dropdownPosition === "right" ? 0 : "initial"};
            ${elevation(props.dropdownShadow ? 1 : 0)};
        `)};
`;

const subLabel = (theme: Theme) => css`
    color: ${theme.colors.gray[700]};
`;
